/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {v4 as get_uuid} from "uuid";
import {ArgsProps as NotificationArgsProps} from "antd/lib/notification/interface";
import {notification, Spin} from "antd";
import {checkForNotifications, download, get} from "./request";
import {triggerReload} from "../reducers/reloadsignal-reducer";
import {store} from "../store";

interface NotificationData {
    'title': string,
    'content': string,
    'type': number,
    'job_uuid'?: string,
    'duration'?: number
}

const number2notificationType = (type: number) => {
    switch (type) {
        case 0:
        default:
            return undefined
        case 1:
            return 'success'
        case 2:
            return 'info'
        case 3:
            return 'warning'
        case  4:
            return 'error'
    }
}

const monitorProgress = (props: any) => {
    let {config, job_uuid} = props;
    get("download/" + job_uuid + "/status")
        .done(
            (data, status, jqXHR) => {
                let desc = "Verarbeitung abgeschlossen."
                switch (jqXHR.status) {
                    case 202:
                        // still working
                        setTimeout(monitorProgress, 3000, props);  // check again in 3 sec
                        break
                    // @ts-ignore: fall through
                    case 200:
                    case 204:
                    case 206:
                        let status = 'success';

                        if (jqXHR.status === 200) {  // done, ready to download
                            setTimeout(download, 0, "download/" + job_uuid + "?token=" + data?.data['token'])  // issue download
                        }

                        if (jqXHR.status === 206) {  // done, return message
                            desc = data['data']['description']
                        }

                        // done, no download
                        notification.open({
                            ...config,
                            type: "success",
                            icon: undefined,
                            description: desc,
                            duration: 10,
                            onClick: () => {
                                notification.destroy(config.key)
                            },
                        } as NotificationArgsProps);
                        break
                    default:
                        break;
                }
            }
        ).fail(
        (jqXHR) => {
            switch (jqXHR.status) {
                case 409:
                    notification.open({
                        ...config,
                        type: 'error',
                        icon: undefined,
                        description: "Fehler bei der Verarbeitung.",
                        onClick: () => {
                            notification.destroy(config.key)
                        },
                    } as NotificationArgsProps);
                    break
                case 404:
                    notification.open({
                        ...config,
                        type: 'error',
                        icon: undefined,
                        description: "Job nicht gefunden.",
                        onClick: () => {
                            notification.destroy(config.key)
                        },
                    } as NotificationArgsProps);
                    break
                default:
                    let desc = jqXHR.responseText;
                    if (!!jqXHR.responseJSON?.data?.description) {
                        desc = jqXHR.responseJSON.data.description;
                    }
                    if (desc === undefined) {
                        desc = "Fehler bei der Verarbeitung.";
                    }


                    // failed
                    notification.open({
                        ...config,
                        type: 'error',
                        icon: undefined,
                        description:
                            <>
                                {
                                    desc.split("\n").map((line: string, index: number) => {
                                        return <p key={index}>{line}</p>
                                    })
                                }
                            </>,
                        onClick: () => {
                            notification.destroy(config.key)
                        },
                    } as NotificationArgsProps);
            }
        }
    ).always(
        checkForNotifications
    )
}


const handleProgressNotification = (data: NotificationData) => {
    let notification_uuid = get_uuid();
    let job_uuid = data.job_uuid;

    let config: NotificationArgsProps = {
        key: notification_uuid,
        message: data.title,
        description: data.content,
        type: 'info',
        icon: <Spin spinning/>,
        duration: 0,
        placement: 'bottomLeft',
    }
    setTimeout(notification.open, 0, config);  // handle popup async

    setTimeout(monitorProgress, 0, {config, job_uuid})
}

const handleNotifications = (data: NotificationData) => {
    let uuid = get_uuid();
    let config: NotificationArgsProps = {
        message: data.title,
        description: data.content,
        type: number2notificationType(data.type),
        key: uuid,
        onClick: () => {
            notification.destroy(uuid)
        }
    }
    if (data.duration) {
        config['duration'] = data.duration;
    }

    setTimeout(notification.open, 0, config); // handle popup async

}

const handlePopups = (data: NotificationData) => {
    if (data.type == 9) {
        // init progress notification
        setTimeout(handleProgressNotification, 0, data)  // handle popup async
    } else if (data.type == 8) {
        // trigger reload event for keyword in content
        store.dispatch(triggerReload(data.content));
    } else {
        // show notification
        handleNotifications(data);
    }
}

export {handlePopups}